/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.23",
    versionName: "0.7.0-nightly.2026.9.23",
    versionChannel: "nightly",
    buildDate: "2026-09-23T00:17:07.937Z",
    commitHash: "7807e400219b41fcf55ac0728b784d2bb8de37a3",
};
